import React from 'react';

import WhatAreSteroids from './whatAreSteroids';
import CommonForms from './commonForms';
import CommonPatterns from './commonPatterns';
import Motivations from './motivations';
import GBQ from './gbq';
import HarmReduction from './harmReduction';
import Game from '../components/game';
import Resources from './resources';

const SiteBase = (props) => {

  return (
    <>
    <header className="site-header">
      <h1>A Harm Reduction Guide to Anabolic Androgenic Steroids (Testosterone)</h1>
      <nav class="site-nav">
        <a href="#/">Home</a>
        <a href="#/patients">For Patients</a>
        <a href="#/providers">For Providers</a>
      </nav>
    </header>

    <main>
      <WhatAreSteroids/>
      <CommonForms/>
      <CommonPatterns/>
      <Motivations/>
      <GBQ/>
      <HarmReduction patientSite={props.patientSite}/>
      <Game patientSite={props.patientSite}/>
      <Resources/>
    </main>
    </>
  );

}

export default SiteBase;